import {spawnErrorToast} from '@hm/fundamental'
import {useQueryClient, useMutation} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {putAnswer} from '../../common/backend'
import {FEATURE_NAMESPACE} from '../../consts'
import {QuestionAnswer} from '../../types'

export const useSubmitAnswer = (onSuccess?: (answer: QuestionAnswer) => void) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const client = useQueryClient()

  return useMutation({
    mutationFn: ({plantId, questionId, answer}: QuestionAnswer) =>
      putAnswer({plantId, questionId, answer}),
    onSuccess: (result: QuestionAnswer) => {
      onSuccess?.(result)
      void client.invalidateQueries()
    },
    onError: () => {
      spawnErrorToast(t('questionnaire.questionSubmitted.error'))
    }
  })
}
